<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.giveawayStockRequests' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.giveawayStockRequests' | translate}}</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchTitle' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
        </div>

      
        <div class="col-sm-3 margin-top-20 left-10 cursor-pointer" *ngIf="canAddGiveawayStock" (click)="add()">
          <span class="margin-right-7 create-new-span">{{'giveaways.addStock' | translate}}</span>
          <i class="fa fa-plus-circle"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-save-giveaway-stock *ngIf="addNew" (closeEvent)="closeAdding($event)" [stockId]="selectedId"></crm-save-giveaway-stock>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="stocks" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th style="text-align:center" class="table-edit">{{'giveaways.itemName' |translate}}</th>
                <th style="text-align:center" class="table-edit">{{'giveaways.quantity'|translate}}</th>
                <th style="text-align:center" class="table-edit">{{'giveaways.date'|translate}}</th>
                <th *ngIf="canEditGiveawayStock">{{'app.edit' |translate}}</th>
                <th *ngIf="canDeleteGiveawayStock">{{'app.delete' |translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-request>
              <tr *ngIf="stocks.length>0 && displayMode==2">
                <td style="text-align:center">{{request.giveawayItemName}}</td>
                <td style="text-align:center">{{ request.quantity  }}</td>
                <td style="text-align:center">{{ request.creationDate | date :'dd/MM/yyyy'  }}</td>
                <td><a *ngIf="canEditGiveawayStock" href="javascript:;" (click)="edit(request.id)"><i class="fa fa-edit fa-lg font-size-20"></i></a></td>
                <td><a *ngIf="canDeleteGiveawayStock" href="javascript:;" (click)="confirmDelete(request)"><i class="fa fa-trash-o  fa-lg font-size-20"></i></a></td>
              </tr>
              <tr *ngIf="stocks.length==0 && displayMode==2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="5">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="5">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>

              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
    </div>
  </div>
</div>



<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="deleteRequest()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>



